import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import languageDictionary from 'src/app/shared/transloco/default';
import { TranslationService } from 'src/app/shared/transloco/services/translation.service';
import { TranslocoRootModule } from 'src/app/shared/transloco/transloco-root.module';
import { NestedPropertyOf } from 'src/app/shared/transloco/types/nested-key-of.type';

@Component({
    selector: 'app-error',
    standalone: true,
    imports: [CommonModule, TranslocoRootModule],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss',
})
export class ErrorComponent {
    private activatedRoute = inject(ActivatedRoute);
    private translationService = inject(TranslationService);

    public message$ = this.activatedRoute.queryParams.pipe(
        map((params) => {
            const message = this.translationService.translate(`error.hints.${params.id}` as NestedPropertyOf<typeof languageDictionary>);
            return message;
        })
    );
}
